export default function getResource(label) {
    const resources = {
        freeReturns: 'Retours gratuits sur tous les achats*'
    };

    return resources[label];
}
